import React from 'react'

export const NWShortCutContext = React.createContext({
  registerNWGlobalHotKey: () => {},
  unRegisterNWGlobalHotKey: () => {},
})
